var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 181,
    viewBox: "0 0 228 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.828 73.7926C129.124 49.2499 96.1859 39.9074 68.2345 50.1098C46.5677 58.017 21.3048 80.0719 22.6447 110.392C23.8958 138.712 47.7202 159.851 70.117 165.434C103.094 173.659 143.34 150.734 158.685 107.449C160.891 109.92 174.247 124.369 195.489 124.418C209.378 124.449 219.402 118.314 223.309 115.609C216.658 110.413 204.15 99.2028 195.791 80.5431C186.046 58.7706 187.448 39.1362 188.552 30.7085C183.881 32.04 177.737 34.459 171.611 39.0578C155.813 50.9028 151.843 68.3915 150.837 73.8035L150.828 73.7926Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1668 122.311C20.4404 132.71 30.266 139.407 40.1129 137.271C49.9599 135.135 56.0993 124.974 53.8258 114.576L53.0816 111.172C50.8081 100.774 40.9825 94.0763 31.1355 96.2124C21.2886 98.3486 15.1491 108.51 17.4227 118.908L18.1668 122.311Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0125 131.317C33.6968 130.297 36.3189 124.074 34.8692 117.418C33.4194 110.762 28.4468 106.194 23.7625 107.214C19.0781 108.234 16.456 114.457 17.9058 121.113C19.3555 127.769 24.3282 132.337 29.0125 131.317Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6709 134.331L27.3618 125.503L38.8208 124.91L32.6709 134.331Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9632 115.204C16.9647 113.164 17.2379 108.014 20.6389 103.389C24.9696 97.4964 33.0603 94.216 40.7727 96.9511C50.2415 100.31 52.9224 110.525 53.081 111.172C41.649 97.2891 20.2543 101.741 16.9632 115.204Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7602 76.508L59.9885 75.1612C56.4962 74.8428 53.9232 71.7535 54.2416 68.2611L54.2422 68.2548C54.5606 64.7625 57.6498 62.1895 61.1422 62.5079L75.9139 63.8547C79.4062 64.1731 81.9792 67.2624 81.6608 70.7547L81.6602 70.7611C81.3418 74.2534 78.2525 76.8264 74.7602 76.508Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4247 80.4553L25.7999 70.9358C28.4893 68.6851 32.4939 69.0408 34.7446 71.7301L34.7486 71.735C36.9993 74.4244 36.6436 78.429 33.9542 80.6797L22.579 90.1992C19.8897 92.4498 15.885 92.0941 13.6344 89.4048L13.6303 89.3999C11.3797 86.7105 11.7354 82.7059 14.4247 80.4553Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2045 137.038C54.5329 137.983 50.0421 139.918 49.9854 141.965C49.9293 143.876 53.7343 145.511 55.475 146.181C54.1592 148.672 53.7297 151.413 54.9002 152.796C56.4622 154.655 61.2802 154.541 65.5218 150.617",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.603 96.102C116.585 97.8639 129.562 99.6272 142.546 101.395C141.684 107.758 139.164 111.822 137.45 114.035C129.969 123.69 115.278 127.152 100.166 123.084",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.317 108.344C138.481 108.532 102.881 105.634 102.881 105.634",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M131.558 118.603L100.409 115.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1439 53.6503C62.4688 48.0282 59.7998 42.4047 57.1232 36.7764C73.3491 25.086 93.7361 23.5675 108.541 32.8003C120.699 40.3882 125.013 52.6959 126.285 56.9437",
    fill: "#CCE5FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1439 53.6503C62.4688 48.0282 59.7998 42.4047 57.1232 36.7764C73.3491 25.086 93.7361 23.5675 108.541 32.8003C120.699 40.3882 125.013 52.6959 126.285 56.9437",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4688 30.5674C74.8937 37.1282 77.3185 43.689 79.7433 50.2498L72.4688 30.5674Z",
    fill: "#5B5BD8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4688 30.5674C74.8937 37.1282 77.3185 43.689 79.7433 50.2498",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.033 32.0399C107.458 38.6007 109.883 45.1615 112.308 51.7223L105.033 32.0399Z",
    fill: "#5B5BD8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.033 32.0399C107.458 38.6007 109.883 45.1615 112.308 51.7223",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9977 28.1061C90.4225 34.6669 92.8473 41.2277 95.2721 47.7885L87.9977 28.1061Z",
    fill: "#5B5BD8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9977 28.1061C90.4225 34.6669 92.8473 41.2277 95.2721 47.7885",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.68 107.448C159.711 104.801 160.757 101.486 161.431 97.5859C161.986 94.4048 162.174 91.5244 162.189 89.0757L173.571 118.923C170.771 117.458 167.496 115.438 164.126 112.651C161.991 110.881 160.183 109.112 158.675 107.456L158.68 107.448Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9232 115.169C52.1967 125.567 62.0223 132.265 71.8693 130.129C81.7162 127.993 87.8557 117.831 85.5821 107.433L84.8379 104.03C82.5644 93.6316 72.7388 86.9339 62.8919 89.0701C53.0449 91.2062 46.9055 101.367 49.179 111.766L49.9232 115.169Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7683 124.175C65.4527 123.154 68.0748 116.932 66.625 110.276C65.1753 103.62 60.2026 99.0514 55.5183 100.072C50.834 101.092 48.2119 107.315 49.6616 113.971C51.1114 120.626 56.084 125.195 60.7683 124.175Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4273 127.189L59.1182 118.361L70.5771 117.767L64.4273 127.189Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7196 108.061C48.721 106.021 48.9942 100.872 52.3953 96.2462C56.726 90.3541 64.8167 87.0736 72.5291 89.8088C81.9979 93.1678 84.6788 103.383 84.8374 104.03C73.4053 90.1468 52.0107 94.5985 48.7196 108.061Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.7284a25b24640017493821692bf45b26.svg";
export { ForwardRef as ReactComponent };